<template>
  <div class="common-content">
    <div class="explain">
      <div class="explain-txt">
        请提出您的宝贵意见和建议，您的心声也是我们前进的动力，
      </div>
      <div class="explain-txt">
        欢迎您将建议反馈给我们，我们将努力改进并完善。
      </div>
    </div>
    <div class="input">
      <el-form ref="form" :rules="rules" :model="form" label-width="80px">
        <el-form-item label="企业名称" prop="name">
          <el-input
            v-model.trim="form.name"
            maxlength="20"
            show-word-limit
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="phone">
          <el-input v-model.number="form.phone" clearable></el-input>
        </el-form-item>
        <el-form-item label="留言内容" prop="desc">
          <el-input
            type="textarea"
            v-model.trim="form.desc"
            maxlength="150"
            :rows="12"
            show-word-limit
            resize="none"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="btn">
      <el-row style="display: flex; justify-content: space-between">
        <el-button class="submit" :disabled="disabled" @click="submit">提交留言</el-button>
        <el-button class="clear" @click="clear">重置</el-button>
      </el-row>
    </div>
  </div>
</template>

<script>
import { addMessageToBoard } from "../api/message";
export default {
  data() {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("联系方式不能为空"));
      }
      setTimeout(() => {
        if (!Number.isInteger(value)) {
          callback(new Error("请输入数字值"));
        } else {
          if (value.toString().length != 11) {
            callback(new Error("联系方式位数不对"));
          } else {
            callback();
          }
        }
      }, 500);
    };
    var checkDes = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("留言内容不能为空"));
      }
      setTimeout(() => {
        if (value.length > 150) {
          callback(new Error("最多输入150字"));
        } else {
          callback();
        }
      }, 500);
    };
    return {
      form: {
        name: "",
        phone: "",
        desc: "",
      },
      disabled:false,
      rules: {
        name: [
          {
            required: true,
            validator: function (rule, value, callback) {
              if (!value) {
                callback(new Error("请输入企业名称"));
              }
              //校验中文的正则：/^[\u4e00-\u9fa5]{0,}$/
              if (/^[\u4e00-\u9fa5]+$/.test(value) == false) {
                callback(new Error("请输入中文"));
              } else {
                //校验通过
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        desc: [{ required: true, validator: checkDes, trigger: "blur" }],
        phone: [{ required: true, validator: checkPhone, trigger: "blur" }],
      },
    };
  },
  methods: {
    submit() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.disabled = true
          await addMessageToBoard({
            username: this.form.name,
            contact: this.form.phone,
            content: this.form.desc,
          });
          this.$notify({
            title: "成功",
            message: "提交成功",
            type: "success",
          });
          this.clear();
          this.disabled = false
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    clear() {
      this.form.name = "";
      this.form.phone = "";
      this.form.desc = "";
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-button {
  width: 162px;
  height: 40px;
}
.submit {
  background-color: #b7171d;
  border-color: #b7171d;
  color: #ffffff;
}

.clear:hover {
  background-color: #ffffff;
  border-color: #dcdfe6;
  color: #606266;
}

.clear:focus {
  background-color: #ffffff;
  border-color: #dcdfe6;
  color: #606266;
}
.submit:hover {
  background-color: #b7171d;
  border-color: #b7171d;
  color: #ffffff;
}
.submit:focus {
  background-color: #b7171d;
  border-color: #b7171d;
  color: #ffffff;
}
.common-content {
  padding: 20px;
  .btn {
    width: 503px;
    margin: 0 auto;
    text-align: center;
  }
  .input {
    width: 503px;
    margin: 0 auto;
  }
  .explain {
    width: 526px;
    margin: 40px auto 63px auto;
    .explain-txt {
      font-size: 18px;
      font-weight: 400;
      color: rgba(119, 119, 119, 1);
      line-height: 40px;
      text-align: center;
    }
  }
}
</style>